import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectThemeMode } from '../../../redux/diagram/diagram.selectors';


import { selectIsModalPricingPlanUpgradeEnabled } from '../../../redux/main/main.selectors';
import { togglePricingPlanUpgrade } from '../../../redux/main/main.actions';


import { CloseButtonIcon } from "../../Icon";

import Modal from '../Modal/Modal';


import './ModalPricingPlanUpgrade.scss';



const plansData = [
    {
        id: 'free',
        name: "Free",
        monthlyPrice: 0,
        annualPrice: 0,
        buttonText: "Get Free",
        featuresHeader: "",
        features: [
            "3 Private Diagrams",
            "40 Tables / Diagram",
            "Areas & Table Groups",
            '“Keys Only” View',
            "Pen Drawing",
            "Export as Image / SQL",
            "Sticky Notes (soon)",
            // "Export as SQL",
            // "History (One Version)",
        ],
    },
    {
        id: 'personal',
        name: "Personal",
        monthlyPrice: 14,
        annualPrice: 10,
        buttonText: "Get Personal",
        featuresHeader: "Everything in Free, plus",
        features: [
            "Unlimited Private Diagrams",
            "Unlimited Tables / Diagram",
            // "Export as Documentation",
            "Live Collaboration",
            "Comments & Threads (soon)",
            "Version History (soon)",
        ],
    },
    {
        id: 'business',
        name: "Business",
        monthlyPrice: 70,
        annualPrice: 50,
        buttonText: "Get Business",
        featuresHeader: "Everything in Personal, plus",
        features: [
            "5 User Licences",
            "Workspaces & Projects",
            // Team Pricing Plan
            // - (old) Team Workspace
            // - (new) Workspaces & Teams & Projects

            // "Unified Access Management",
            "Team Access Management",
            // "Unified Billing Management",
            "Centralized Billing",
            "Additional Users — $5/user/month",
            "Audit Logs (soon)",
        ],
    },
    // {
    //     id: 'enterprise',
    //     name: "Enterprise",
    //     monthlyPrice: 'Custom',
    //     annualPrice: 'Custom',
    //     buttonText: "Contact Us",
    //     featuresHeader: "Everything in Business, plus",
    //     features: [
    //         "Customized plan",
    //         "High priority support",
    //         "Org-wide onboarding",
    //         "Org-wide training",
    //         "Audit Logs Management",
    //         "More Licences: $5 /month /user",
    //     ],
    // },
];

export const ModalPricingPlanUpgrade = () => {
    const isOpen = useSelector(selectIsModalPricingPlanUpgradeEnabled);

    const isLightTheme = useSelector(selectThemeMode);

    const selectedPlanId = 'free';

    const dispatch = useDispatch();


    const handleCancel = () => {
        dispatch(togglePricingPlanUpgrade({}));
    };




    const [isSwitchYearHovered, setIsSwitchYearHovered] = useState(false);
    const [isSwitchMonthHovered, setIsSwitchMonthHovered] = useState(false);

    const [isAnnual, setIsAnnual] = useState(true);
    const [isAnnualDelayed, setIsAnnualDelayed] = useState(true);

    const handleTogglePricingSwitch = () => {
        setIsAnnual(!isAnnual);

        setTimeout(() => {
            setIsAnnualDelayed(!isAnnual);
        }, 200);
    };



    return (
        <Modal
            isModalFullScreen={true}
            isOpen={isOpen}
            modalClass={`modal-upgrade-plan ${isLightTheme ? 'light' : ''}`}
            onCancel={handleCancel}
        // onShouldRender={handleRender}
        >
            <div className='pricing-wrap'>
                <button className="close-button" onClick={handleCancel}>
                    <CloseButtonIcon />
                </button>

                <div className="pricing-title">Upgrade your plan</div>
                <div className="pricing-subtitle">You can always upgrade or downgrade your plan later</div>

                <div className='pricing-switch'>
                    <span className={`pricing-switch-highlight ${(isSwitchYearHovered && isAnnual) || (isSwitchMonthHovered && !isAnnual) ? 'hovered' : ''} ${isAnnual ? 'yearly' : 'monthly'}`}></span>
                    <button
                        className={`pricing-switch-btn yearly ${isAnnual ? 'selected' : ''}`}
                        onMouseEnter={() => setIsSwitchYearHovered(true)}
                        onMouseLeave={() => setIsSwitchYearHovered(false)}
                        onClick={handleTogglePricingSwitch}
                    >Annually <span>-30%</span></button>
                    <button
                        className={`pricing-switch-btn monthly ${!isAnnual ? 'selected' : ''}`}
                        onMouseEnter={() => setIsSwitchMonthHovered(true)}
                        onMouseLeave={() => setIsSwitchMonthHovered(false)}
                        onClick={handleTogglePricingSwitch}
                    >Monthly</button>
                </div>

                <div className="pricing-cards-group">
                    {plansData.map((plan) => {
                        const isFreePlan = plan.id === 'free';
                        const isEnterprisePlan = plan.id === 'enterprise';

                        const price = isAnnualDelayed ? plan.annualPrice : plan.monthlyPrice;
                        const billingText =
                            isFreePlan
                                ? 'Free for everyone'
                                : isAnnualDelayed
                                    ? "Billed annually"
                                    : "Billed monthly";

                        return (
                            <div className="pricing-card" key={plan.id}>
                                <div className="pricing-card-title">{plan.name}</div>
                                <div className="pricing-card-price-section">
                                    {isAnnualDelayed && !isFreePlan && !isEnterprisePlan ? <div className="pricing-card-price-cross">{`${isEnterprisePlan ? plan.monthlyPrice : `$${plan.monthlyPrice}`}`}</div> : ''}
                                    <div className="pricing-card-price">{`${isEnterprisePlan ? price : `$${price}`}`}</div>
                                    {/* <div className="pricing-card-price-period">/month</div> */}
                                    {!isFreePlan && !isEnterprisePlan ? <div className="pricing-card-price-period">/month</div> : ''}

                                </div>
                                <div className="pricing-card-additional-text">{billingText}</div>

                                <hr className='horizontal-line' />

                                <button className={`pricing-card-selection-button ${selectedPlanId === plan.id ? 'selected' : ''}`}>{selectedPlanId === plan.id ? 'Selected plan' : plan.buttonText}</button>

                                <ul className="pricing-card-features">
                                    {plan.featuresHeader ?
                                        <li className='pricing-card-features-item features-header'>
                                            <span>{plan.featuresHeader}</span>
                                        </li>
                                        : ''
                                    }

                                    {plan.features.map((feature, index) => (
                                        <li key={index} className='pricing-card-features-item'>
                                            {
                                                (plan.id === 'free' && index === 6) ||
                                                    (plan.id === 'personal' && [3, 4].includes(index)) ||
                                                    (plan.id === 'business' && index === 5)
                                                    // soon
                                                    ? <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" style={{ marginLeft: '-2px', fill: 'none' }}>
                                                        <path d="M12 8V12L15 15" stroke="#b6dcfd" strokeWidth="1.8" strokeLinecap="round"></path>
                                                        <circle cx="12" cy="12" r="9" stroke="#b6dcfd" strokeWidth="1.8"></circle>
                                                    </svg>

                                                    // check
                                                    : <svg className="icon-check" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clipRule="evenodd"></path>
                                                    </svg>
                                            }
                                            <span>{feature}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        );
                    })}
                </div>
            </div>
        </Modal>
    );
};

export default ModalPricingPlanUpgrade;


























// export const ModalPricingPlanUpgrade = () => {
//     const inputRef = useRef(null);

//     const isLightTheme = useSelector(selectThemeMode);

//     const selectedPlanId = 'free';

//     useEffect(() => {
//         if (isOpen && inputRef.current) {
//             inputRef.current.focus();
//         }
//     }, [isOpen]);

//     const dispatch = useDispatch();

//     const [name, setName] = useState('');
//     const [description, setDescription] = useState('');

//     const handleSave = () => {
//     };

//     const handleCancel = () => {
//     };

//     useEffect(() => {
//         const handleKeyPress = (event) => {
//             if (!isOpen) return;

//             if (event.code === 'Escape') {
//                 event.preventDefault();

//                 handleCancel();
//             }
//         };

//         document.addEventListener('keydown', handleKeyPress);
//         return () => {
//             document.removeEventListener('keydown', handleKeyPress);
//         };
//     }, [isOpen, handleCancel]);

//     const [isSwitchYearHovered, setIsSwitchYearHovered] = useState(false);
//     const [isSwitchMonthHovered, setIsSwitchMonthHovered] = useState(false);

//     const [isAnnual, setIsAnnual] = useState(true);
//     const [isAnnualDelayed, setIsAnnualDelayed] = useState(true);

//     const plansData = [
//         {
//             id: 'free',
//             name: "Free",
//             monthlyPrice: 0,
//             annualPrice: 0,
//             buttonText: "Get Free",
//             featuresHeader: "",
//             features: [
//                 "3 Private Diagrams",
//                 "40 Tables / Diagram",
//                 "Sticky Notes",
//                 "Areas & Table Groups",
//                 '“Keys Only” View',
//                 "Pen Drawing",
//                 "Export as Image",
//                 "Export as SQL",
//             ],
//         },
//         {
//             id: 'personal',
//             name: "Personal",
//             monthlyPrice: 14,
//             annualPrice: 10,
//             buttonText: "Get Personal",
//             featuresHeader: "Everything in Free, plus",
//             features: [
//                 "Unlimited Private Diagrams",
//                 "Unlimited Tables / Diagram",
//                 "Version History",
//                 "Comments / Threads",
//                 "Export as Documentation",
//                 "Live User Collaboration",
//                 "Live User Collaboration",
//             ],
//         },
//         {
//             id: 'business',
//             name: "Business",
//             monthlyPrice: 70,
//             annualPrice: 50,
//             buttonText: "Get Business",
//             featuresHeader: "Everything in Personal, plus",
//             features: [
//                 "5 User Licences",
//                 "Team Workspace",
//                 // Team Pricing Plan
//                 // - (old) Team Workspace
//                 // - (new) Workspaces & Teams & Projects
//                 "Unified Access Management",
//                 "Unified Billing Management",
//                 "Audit Logs Management",
//                 "More Licences: $5 /month /user",
//             ],
//         },
//         // {
//         //     id: 'enterprise',
//         //     name: "Enterprise",
//         //     monthlyPrice: 'Custom',
//         //     annualPrice: 'Custom',
//         //     buttonText: "Contact Us",
//         //     featuresHeader: "Everything in Business, plus",
//         //     features: [
//         //         "Customized plan",
//         //         "High priority support",
//         //         "Org-wide onboarding",
//         //         "Org-wide training",
//         //         "Audit Logs Management",
//         //         "More Licences: $5 /month /user",
//         //     ],
//         // },
//     ];

//     const handleTogglePricingSwitch = () => {
//         setIsAnnual(!isAnnual);

//         setTimeout(() => {
//             setIsAnnualDelayed(!isAnnual);
//         }, 200);
//     };




//     if (!isOpen) return null;


//     return (
//         // <div className={`modal-upgrade-plan ${isLightTheme ? 'merged' : ''}`}>
//         <div className={`modal-upgrade-plan ${isLightTheme ? 'light' : ''}`}>
//             <div className="modal-overlay"></div>
//             <div className="modal-content">
//                 <div className='pricing-wrap'>
//                     <button className="close-button" onClick={handleCancel}>
//                         <CloseButtonIcon />
//                     </button>

//                     <div className="pricing-title">Upgrade your plan</div>
//                     <div className="pricing-subtitle">Choose a plan that works best for you. You can always upgrade or downgrade your plan later.</div>

//                     <div className='pricing-switch'>
//                         <span className={`pricing-switch-highlight ${(isSwitchYearHovered && isAnnual) || (isSwitchMonthHovered && !isAnnual) ? 'hovered' : ''} ${isAnnual ? 'yearly' : 'monthly'}`}></span>
//                         <button
//                             className={`pricing-switch-btn yearly ${isAnnual ? 'selected' : ''}`}
//                             onMouseEnter={() => setIsSwitchYearHovered(true)}
//                             onMouseLeave={() => setIsSwitchYearHovered(false)}
//                             onClick={handleTogglePricingSwitch}
//                         >Annually <span>-30%</span></button>
//                         <button
//                             className={`pricing-switch-btn monthly ${!isAnnual ? 'selected' : ''}`}
//                             onMouseEnter={() => setIsSwitchMonthHovered(true)}
//                             onMouseLeave={() => setIsSwitchMonthHovered(false)}
//                             onClick={handleTogglePricingSwitch}
//                         >Monthly</button>
//                     </div>

//                     <div className="pricing-cards-group">
//                         {plansData.map((plan) => {
//                             const isFreePlan = plan.id === 'free';
//                             const isEnterprisePlan = plan.id === 'enterprise';

//                             const price = isAnnualDelayed ? plan.annualPrice : plan.monthlyPrice;
//                             const billingText =
//                                 isFreePlan
//                                     ? 'Free for everyone'
//                                     : isAnnualDelayed
//                                         ? "Billed annually"
//                                         : "Billed monthly";

//                             return (
//                                 <div className="pricing-card" key={plan.id}>
//                                     <div className="pricing-card-title">{plan.name}</div>
//                                     <div className="pricing-card-price-section">
//                                         {isAnnualDelayed && !isFreePlan && !isEnterprisePlan ? <div className="pricing-card-price-cross">{`${isEnterprisePlan ? plan.monthlyPrice : `$${plan.monthlyPrice}`}`}</div> : ''}
//                                         <div className="pricing-card-price">{`${isEnterprisePlan ? price : `$${price}`}`}</div>
//                                         {/* <div className="pricing-card-price-period">/month</div> */}
//                                         {!isFreePlan && !isEnterprisePlan ? <div className="pricing-card-price-period">/month</div> : ''}

//                                     </div>
//                                     <div className="pricing-card-additional-text">{billingText}</div>

//                                     <hr className='horizontal-line' />

//                                     <button className={`pricing-card-selection-button ${selectedPlanId === plan.id ? 'selected' : ''}`}>{selectedPlanId === plan.id ? 'Selected plan' : plan.buttonText}</button>

//                                     <ul className="pricing-card-features">
//                                         {plan.featuresHeader ?
//                                             <li className='pricing-card-features-item features-header'>
//                                                 <span>{plan.featuresHeader}</span>
//                                             </li>
//                                             : ''
//                                         }

//                                         {plan.features.map((feature, index) => (
//                                             <li key={index} className='pricing-card-features-item'>
//                                                 <svg className="icon-check" viewBox="0 0 20 20">
//                                                     <path fillRule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clipRule="evenodd"></path>
//                                                 </svg>
//                                                 <span>{feature}</span>
//                                             </li>
//                                         ))}
//                                     </ul>
//                                 </div>
//                             );
//                         })}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ModalPricingPlanUpgrade;



